// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__5KoxC","message":"Messages_message__Wo8pN","text":"Messages_text__QyQDo","user":"Messages_user__QMy83","me":"Messages_me__H2F0T"};